class ProductHelpVideosSearch {
  constructor() {
    this.searchInput = document.getElementById('product-help-search');
    this.resultsInfo = document.getElementById('product-help-search-results-info');
    
    this.init();
  }

  init() {
    if (!this.searchInput || !this.resultsInfo) return;
    
    this.setupEventListeners();
  }

  setupEventListeners() {
    this.searchInput.addEventListener('input', this.handleSearch.bind(this));
  }

  handleSearch() {
    const query = this.searchInput.value.trim();
    
    if (query.length === 0) {
      this.resultsInfo.innerHTML = '';
      this.resultsInfo.style.display = 'none';
      return;
    }

    this.performSearch(query);
  }

    performSearch(query) {
    // Find all elements with the class "product-help-video-sub-tab-heading"
    const headingElements = document.querySelectorAll('.product-help-video-sub-tab-heading');
    const matchedResults = [];
    let index = 0;
    
    headingElements.forEach((element) => {
      const text = element.textContent.toLowerCase();
      const searchQuery = query.toLowerCase();
      
      // Check if the text contains the search query
      if (text.includes(searchQuery)) {
        // Find the parent element with class "accordion-item sub-accordion-item"
        const parentElement = element.closest('.accordion-item.sub-accordion-item');
        
        if (parentElement) {
          // Create a unique identifier for this parent element
          if (!parentElement.dataset.searchProcessed) {
            // Mark this parent as processed to avoid duplicates
            parentElement.dataset.searchProcessed = 'true';
            
            // Clone the parent element to avoid modifying the original
            const clonedElement = parentElement.cloneNode(true);
            
            // Find the sub-tab-card-header element in the cloned element and apply alternating colors
            const subTabHeader = clonedElement.querySelector(".sub-tab-card-header");
            if (subTabHeader) {
              if (index % 2 == 0) {
                subTabHeader.style.setProperty("background-color", "rgba(139, 139, 139, 0.2)", "important");
              } else {
                subTabHeader.style.setProperty("background-color", "rgba(139, 139, 139, 0.06)", "important");
              }
            }
            
            matchedResults.push(clonedElement.outerHTML);
            index++;
          }
        }
      }
    }); 

    // Clean up the processed markers
    document.querySelectorAll('[data-search-processed]').forEach(el => {
      delete el.dataset.searchProcessed;
    });

    // Display results
    if (matchedResults.length > 0) {
      this.resultsInfo.innerHTML = matchedResults.join('');
      this.resultsInfo.style.display = 'block';
      this.resultsInfo.removeAttribute('data-no-results');
    } else {
      this.resultsInfo.innerHTML = 'No results found';
      this.resultsInfo.style.display = 'block';
      this.resultsInfo.setAttribute('data-no-results', 'true');
    }
  }
}

// Initialize when DOM is loaded
document.addEventListener('DOMContentLoaded', function() {
  new ProductHelpVideosSearch();
});

// Also initialize if DOM is already loaded
if (document.readyState !== 'loading') {
  new ProductHelpVideosSearch();
} 